import React from 'react';
import { PreAuthNavbar } from '@/components/navigation/PreAuthNavbar';
import { PostAuthNavbar } from '@/components/navigation/PostAuthNavbar';
import { Footer } from '@/components/marketing/Footer';
import { UserRound, HandHelping } from 'lucide-react';
import { useAuth } from '@/providers/AuthProvider';

const ContactPage: React.FC = () => {
    const { isAuthenticated } = useAuth();

    return (
        <div className="min-h-screen flex flex-col">
            {isAuthenticated ? <PostAuthNavbar /> : <PreAuthNavbar />}
            <main className="flex-1 max-w-4xl mx-auto px-4 py-16">
                <div className="text-center mb-12">
                    <h1 className="text-4xl font-bold mb-4">Contact Us</h1>
                    <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                        We'd love to hear from you! Whether you have questions about Arrowise, need support, or want to share feedback, we're here to help.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 gap-12">
                    <div className="space-y-8">
                        <section>
                            <h2 className="text-2xl font-semibold mb-4">Get in Touch</h2>
                            <p className="text-muted-foreground mb-6">
                                Reach out to us directly via email. We're committed to responding promptly to all inquiries.
                            </p>
                            <div className="space-y-4">
                                <div className="flex items-center space-x-3">
                                    <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
                                        <UserRound className="w-5 h-5 text-primary" />
                                    </div>
                                    <div>
                                        <p className="font-medium">General Inquiries</p>
                                        <a href="mailto:omar.benhmuda@outlook.com" className="text-primary underline">
                                            omar.benhmuda@outlook.com
                                        </a>
                                    </div>
                                </div>
                                <div className="flex items-center space-x-3">
                                    <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
                                        <HandHelping className="w-5 h-5 text-primary" />
                                    </div>
                                    <div>
                                        <p className="font-medium">Support</p>
                                        <a href="mailto:omar.benhmuda@outlook.com" className="text-primary underline">
                                            omar.benhmuda@outlook.com
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                    <div className="space-y-8">
                        <section>
                            <h2 className="text-2xl font-semibold mb-4">What We Can Help With</h2>
                            <div className="space-y-4">
                                <div className="p-4 border rounded-lg">
                                    <h3 className="font-medium mb-2">Technical Support</h3>
                                    <p className="text-sm text-muted-foreground">
                                        Issues with sessions, AI features, or platform functionality
                                    </p>
                                </div>
                                <div className="p-4 border rounded-lg">
                                    <h3 className="font-medium mb-2">Billing & Subscriptions</h3>
                                    <p className="text-sm text-muted-foreground">
                                        Questions about plans, payments, or account upgrades
                                    </p>
                                </div>
                                <div className="p-4 border rounded-lg">
                                    <h3 className="font-medium mb-2">Partnerships</h3>
                                    <p className="text-sm text-muted-foreground">
                                        Business inquiries or collaboration opportunities
                                    </p>
                                </div>
                                <div className="p-4 border rounded-lg">
                                    <h3 className="font-medium mb-2">Feedback & Suggestions</h3>
                                    <p className="text-sm text-muted-foreground">
                                        Share your thoughts on how we can improve Arrowise
                                    </p>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>

                <div className="mt-16 text-center">
                    <p className="text-muted-foreground">
                        For privacy-related inquiries, please review our{' '}
                        <a href="/privacy" className="text-primary hover:underline">Privacy Policy</a>.
                    </p>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default ContactPage;
